/** Role IDs with finance view/print only (no create/edit/delete). */
export const FINANCE_READ_ONLY_ROLE_IDS = [36];

const POSITION_KEY = "aria_position_id";

export function setUserPositionId(positionId) {
  if (positionId === null || positionId === undefined || positionId === "") {
    localStorage.removeItem(POSITION_KEY);
    return;
  }
  localStorage.setItem(POSITION_KEY, String(positionId));
}

export function getUserPositionId() {
  const raw = localStorage.getItem(POSITION_KEY);
  if (raw === null || raw === "") return null;
  const n = Number(raw);
  return Number.isFinite(n) ? n : null;
}

export function isFinanceReadOnly() {
  const positionId = getUserPositionId();
  return positionId !== null && FINANCE_READ_ONLY_ROLE_IDS.includes(positionId);
}

const PROCUREMENT_EXPENSE_PATHS = [
  "/mis/expenses/3",
  "/mis/expenses/4",
  "/mis/expenses/5",
];

const PROCUREMENT_BLOCKED_PREFIXES = [
  "/mis/finance/dashboard",
  "/mis/contractors",
  "/mis/contractor/",
  "/mis/expenses/1",
  "/mis/expenses/2",
  "/mis/expenseBudgets",
  "/mis/facultiesPastBalance",
  "/mis/teacherBenefits",
  "/mis/revenues",
];
export function getProcurementExpensePaths() {
  return [...PROCUREMENT_EXPENSE_PATHS];
}

export function isPathBlockedForFinanceReadOnly(pathname = "") {
  if (!isFinanceReadOnly()) return false;
  const path = String(pathname || "").split("?")[0];
  return PROCUREMENT_BLOCKED_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(prefix)
  );
}
